"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const actions_1 = require("../app/actions/actions");
const INIT_STATE = {
    handlingMissingValues: {
        selectedCategoricalRemoveColumns: [],
        selectedCategoricalReplaceWithMode: [],
        selectedCategoricalRemoveRows: [],
        categoricalRemainingColumns: [],
        selectedNumericalRemoveColumns: [],
        selectedNumericalReplaceWithZero: [],
        selectedNumericalReplaceWithMean: [],
        selectedNumericalReplaceWithMedian: [],
        selectedNumericalReplaceWithPrevValue: [],
        selectedNumericalReplaceWithMode: [],
        selectedNumericalRemoveRows: [],
        numericalRemainingColumns: [],
        selectedTargetRemoveColumns: [],
        selectedTargetReplaceWithMode: [],
        selectedTargetRemoveRows: [],
        targetRemainingColumns: [],
        selectedDateTimeRemoveColumns: [],
        selectedDateTimeRemoveRows: [],
        dateTimeRemainingColumns: [],
    },
    outlierVisualizations: {
        outliersData: {}
    },
    interpolationData: {
        interpolationBase: [],
        interpolationFrequency: 5,
        labelColumn: "",
        removeRows: [],
        remainingRows: [],
    },
    lagVariables: {
        lagVariablesColumn: "",
        no_ofLagVariables: 12,
        retainLabels: [],
    }
};
exports.default = (state = INIT_STATE, action) => {
    switch (action.type) {
        case actions_1.SAVE_HANDLING_MISSING_VALUES: {
            return Object.assign({}, state, { selectedCategoricalRemoveColumns: action.payload.selectedCategoricalRemoveColumns, selectedCategoricalReplaceWithMode: action.payload.selectedCategoricalReplaceWithMode, selectedCategoricalRemoveRows: action.payload.selectedCategoricalRemoveRows, categoricalRemainingColumns: action.payload.categoricalRemainingColumns, selectedNumericalRemoveColumns: action.payload.selectedNumericalRemoveColumns, selectedNumericalReplaceWithZero: action.payload.selectedNumericalReplaceWithZero, selectedNumericalReplaceWithMean: action.payload.selectedNumericalReplaceWithMean, selectedNumericalReplaceWithMedian: action.payload.selectedNumericalReplaceWithMedian, selectedNumericalReplaceWithPrevValue: action.payload.selectedNumericalReplaceWithPrevValue, selectedNumericalReplaceWithMode: action.payload.selectedNumericalReplaceWithMode, selectedNumericalRemoveRows: action.payload.selectedNumericalRemoveRows, numericalRemainingColumns: action.payload.numericalRemainingColumns, selectedTargetRemoveColumns: action.payload.selectedTargetRemoveColumns, selectedTargetReplaceWithMode: action.payload.selectedTargetReplaceWithMode, selectedTargetRemoveRows: action.payload.selectedTargetRemoveRows, targetRemainingColumns: action.payload.targetRemainingColumns, selectedDateTimeRemoveColumns: action.payload.selectedDateTimeRemoveColumns, selectedDateTimeRemoveRows: action.payload.selectedDateTimeRemoveRows, dateTimeRemainingColumns: action.payload.dateTimeRemainingColumns });
        }
        case actions_1.SAVE_OUTLIER_VISUALIZATIONS: {
            return Object.assign({}, state, { outliersData: action.payload });
        }
        case actions_1.SAVE_INTERPOLATION_DATA: {
            return Object.assign({}, state, { interpolationBase: action.payload.interpolationBase, interpolationFrequency: action.payload.interpolationFrequency, labelColumn: action.payload.labelColumn, removeRows: action.payload.removeRows, remainingRows: action.payload.remainingRows });
        }
        case actions_1.SAVE_LAG_VARIABLES: {
            return Object.assign({}, state, { lagVariablesColumn: action.payload.lagVariablesColumn, no_ofLagVariables: action.payload.no_ofLagVariables, retainLabels: action.payload.retainLabels });
        }
        default:
            return state;
    }
};
//# sourceMappingURL=handling-missing-values.js.map